import React, { useEffect, useState, useContext } from "react";
import "./OurPartner.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay, FreeMode } from "swiper/modules";

import { Context } from "../../../../utils/context";
import Common_Title from "../../../common_components/common_title/Common_Title";

const OurPartner = () => {
  const { getData, imageUrl } = useContext(Context);

  const [ourPartner, setOurPartner] = useState([]);

  const getBlogs = async () => {
    const res = await getData("/without-login/master/all-our-partners");

    if (res?.success) {
      setOurPartner(res.data);
    }
  };

  useEffect(() => {
    getBlogs();
  }, []);

  return (
    <section className="our-partner-section">
      <div className="container">
        <Common_Title title="Our " subTitle="Partners" />

        <div className="cards">
          <div className="partner-marquee">
            <div className="partner-track">
              {[...ourPartner, ...ourPartner].map((value, index) => (
                <div className="partner-item" key={index}>
                  <img
                    src={imageUrl + value?.image}
                    alt="partner-logo"
                    className="company-logo"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurPartner;
